module.exports = __webpack_public_path__ + "static/media/E_lean2.32442f9a.png";